import { NgModule } from '@angular/core';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomFormsModule } from 'ng2-validation';
import { BrowserModule } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { HttpModule, Http, XHRBackend, RequestOptions } from '@angular/http';
import { ToastrModule } from 'toastr-ng2';

import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { CustomHttp } from './core/custom-http';
import { TokenService, AppSettingsService, EndpointsService, ClaimsService } from './core/services';
import { DashboardAdminModule } from './dashboard/dashboard-admin.module';
import { UsersModule } from './users/users.module';

import { AccountBarComponent, AppComponent, LoginComponent, NavBarComponent, NotFoundComponent, ForgotPasswordComponent, ResetPassWordComponent } from './';
import { CampaignsModule } from "./campaigns/campaigns.module";
import { BrandLogosModule } from "./brand-logos/brand-logos.module";
import { CreativeModule } from "./creatives/creative.module";
import { AssetModule } from "./assets/asset.module";
import { BrandPreidModule } from "./brand-preid/brand-preid.module";
import { MediationModule } from './mediation/mediation.module';
import { PaymentModule } from "./payment/payment.module";
import { CustomDateFormatPipe } from '../app/shared/custom-date-format.pipe';
import { ProviderModule } from "./providers/provider.module";
import { PublishersModule } from "./publishers/publishers.module";
import { PublisherDashboardModule } from "./dashboard/publisher-dashboard/publisher-dashboard.module";
import { ReportsModule } from "./reports/reports.module";
import { Ng2AutoCompleteModule } from 'ng2-auto-complete';
import { VgCoreModule } from 'videogular2/core';
import { VgControlsModule } from 'videogular2/controls';
import { VgOverlayPlayModule } from 'videogular2/overlay-play';
import { VgBufferingModule } from 'videogular2/buffering';
import { BrandStatisticsModule } from './brand-statistics/brand-statistics.module';
import { LogoutService } from './core/services/logout.service';

export function httpFactory(backend: XHRBackend,
  defaultOptions: RequestOptions,
  tokenService: TokenService,
  endpointsService: EndpointsService,
  logoutService: LogoutService) {
  return new CustomHttp(backend, defaultOptions, tokenService, endpointsService, logoutService);
}

@NgModule({
  imports: [
    CoreModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    CustomFormsModule,
    ReactiveFormsModule,
    DashboardAdminModule,
    UsersModule,
    CampaignsModule,
    BrandLogosModule,
    CreativeModule,
    AssetModule,
    BrandPreidModule,
    BrandStatisticsModule,
    MediationModule,
    PaymentModule,
    ProviderModule,
    PublishersModule,
    PublisherDashboardModule,
    ReportsModule,
    Ng2AutoCompleteModule,
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
    ToastrModule.forRoot()
  ],
  declarations: [
    AccountBarComponent,
    AppComponent,
    LoginComponent,
    ForgotPasswordComponent,
    ResetPassWordComponent,
    NavBarComponent,
    NotFoundComponent,
    CustomDateFormatPipe
  ],
  providers: [
    {
      provide: Http, useFactory: httpFactory, deps: [XHRBackend, RequestOptions, TokenService, EndpointsService, LogoutService]
    },
    { provide: LocationStrategy, useClass: HashLocationStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }


// WEBPACK FOOTER //
// ./src/app/app.module.ts